import http from "./instance";

export const uploadFile = (formData: any) => {
  return http.upload("/api-base/upload/uploadFile", formData);
};
